import { ManufacturerCreateObj } from "../components/operation/manufacturerNotification/CreateManufacturer";
import { SearchManufacturerRequest } from "../redux/slice/manufacturer/ManufacturerSlice";
import { EDIT_MANUFACTURER_URL, GET_MANUFACTURER_DATA_BY_ID, GET_MANUFACTURER_LIST_BY_PRACTICE_URL, GET_MANUFACTURER_LIST_URL, GET_MANUFACTURERS_BY_ROLE_FOR_COMMISSION_URL, GET_MANUFACTURERS_BY_ROLE_URL, SAVE_MANUFACTURER_URL } from "./URL";
import { http } from "./http";

export const saveManufacturer = async (saveManufacturer: ManufacturerCreateObj) => {
    try{
        const response = await http.post(SAVE_MANUFACTURER_URL, saveManufacturer, undefined, {skipErrorPopup: true});
        return response;
    }
    catch(error){
        throw error;
    }
};
export const editManufacturer = async (EditManufacturerData: ManufacturerCreateObj) => {
    try{
        const response = await http.post(EDIT_MANUFACTURER_URL, EditManufacturerData, undefined, {skipErrorPopup: true});
        return response;
    }
    catch(error){
        throw error;
    }
};

export const getDetailsOfManufacturerById = async (mfrId:number)=>{
    const response = await http.get(`${GET_MANUFACTURER_DATA_BY_ID}?manufacturerId=${mfrId}`);
    return response;
}

export const getManufacturerListByPracticeIds = async (practiceIds:number[])=>{
    const response = await http.get(`${GET_MANUFACTURER_LIST_BY_PRACTICE_URL}?practiceIds=${practiceIds}`);
    return response;
}

export const getManufacturerList = async (data: SearchManufacturerRequest) => {
  try {
    const response = await http.post(GET_MANUFACTURER_LIST_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};
//CS-1625 - Fetching manufacturer list by role
export const getManufacturerListByRole = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(GET_MANUFACTURERS_BY_ROLE_URL, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};

// CS-1765 - Fetch manufacturer list for commission filter using dedicated commission endpoint
export const getManufacturerByRoleForCommission = async (headers: Record<string, string>) => {
    try {
        const response = await http.get(GET_MANUFACTURERS_BY_ROLE_FOR_COMMISSION_URL, { headers: { ...headers } });
        return response;
    } catch (error) {
        throw error;
    }
};
